import SaJooContainer from '../components/sajoo/sajoo-redux'

export default SaJooContainer
